// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
//大数据
import bigdata from '@/views/bigdata/bigdata';
//大数据浏览记录
import bigdatabrowse from '@/views/bigdata/bigdatabrowse';
// 系统配置
import system_config from '@/views/bigdata/system_config';
//用户管理
import users from '@/views/user/user';
//分类
import sort from '@/views/shop/sort';
//分类2
import sort2 from '@/views/shop/sort2';
//品牌
import brand from '@/views/shop/brand';
import brandbrowse from '@/views/shop/brandbrowse';
//产品
import product from '@/views/shop/product';
import productbrowse from '@/views/shop/productbrowse';
// 宣传视频
import video from '@/views/shop/video';
//产品
import service from '@/views/service/service';
//产品
import help from '@/views/help/help';
//幻灯片
import slide from '@/views/slide/slide';
//产品中心
import productCenter from '@/views/productCenter/productCenter';
//商务合作
import business from '@/views/business/business';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
            {
                path: '/bigdata/bigdata',
                name: '大数据',
                component: bigdata,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/bigdata/bigdatabrowse',
                name: '大数据浏览记录',
                component: bigdatabrowse,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/bigdata/system_config',
                name: '系统配置',
                component: system_config,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/shop/brandbrowse',
                name: '品牌浏览记录',
                component: brandbrowse,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/shop/sort',
                name: '分类',
                component: sort,
                meta: {
                    requireAuth: true
                }
            }
            , {
                path: '/shop/sort2',
                name: '分类2',
                component: sort2,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/shop/brand',
                name: '品牌',
                component: brand,
                meta: {
                    requireAuth: true
                }
            }
            , {
                path: '/shop/product',
                name: '产品',
                component: product,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/shop/video',
                name: '宣传视频',
                component: video,
                meta: {
                    requireAuth: true
                }
            }
            , {
                path: '/shop/productbrowse',
                name: '产品浏览记录',
                component: productbrowse,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/user/user',
                name: '用户管理',
                component: users,
                meta: {
                    requireAuth: true
                }
            }
            , {
                path: '/service/service',
                name: '行业咨询',
                component: service,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/help/help',
                name: '咨询帮助',
                component: help,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/slide/slide',
                name: '咨询帮助',
                component: slide,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/goods/Goods',
                name: '商品管理',
                component: Goods,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/productCenter/productCenter',
                name: '产品中心',
                component: productCenter,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/business/business',
                name: '商务合作',
                component: business,
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/machine/Machine',
                name: '机器信息管理',
                component: Machine,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/machine/MachineAisle',
                name: '货道信息管理',
                component: MachineAisle,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/pay/Order',
                name: '交易订单',
                component: Order,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/user',
                name: '用户管理',
                component: user,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Module',
                name: '菜单管理',
                component: Module,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Role',
                name: '角色管理',
                component: Role,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Dept',
                name: '公司管理',
                component: Dept,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Variable',
                name: '系统环境变量',
                component: Variable,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Permission',
                name: '权限管理',
                component: Permission,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/machine/MachineConfig',
                name: '支付配置信息',
                component: MachineConfig,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/pay/Config',
                name: '支付配置',
                component: Config,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/druid/login',
                name: '监控查询',
                component: druidLogin,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/charts/statistics',
                name: '数据可视化',
                component: statistics,
                meta: {
                    requireAuth: true
                }
            }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js